import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import localforage from 'localforage'
import store from '../store'

Vue.use(Router)

const router = new Router({
  routes,
  base: process.env.BASE_URL,
  mode: 'history'
})

const checkAuth = async (to, from, next) => {
  const token = await localforage.getItem('token')
  store.dispatch('setToken', token)

  if (!to.matched.some(record => record.meta.guest)) {
    if (!store.getters.loggedIn) {
      next({
        name: 'login_path',
        query: {
          redirectTo: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    next()
  }
}

router.beforeEach((to, from, next) => {
  console.log(`🚦 navigating to ${to.name} from ${from.name}`)
  checkAuth(to, from, next)
  next()
})

export default router
